const initConsultation = () => {
  const consultationSection = document.querySelector('.consultation');
  const consultationProgressBar = document.querySelector('.consultation .consultation-progress-bar');
  const consultationAdditionalPanels = document.querySelector('.consultation .additional-panels');
  //const consultationCloseBtn = document.querySelector('.consultation .consultation-close');
  const consultationSteps = document.querySelectorAll('.consultation .consultation-step');
  const consultationStepThanks = document.querySelector('.consultation .consultation-step-thanks');
  const consultationNextBtn = document.querySelector('.consultation .consultation-btn');
  const consultationPrevBtn = document.querySelector('.consultation .consultation-back');
  const consultationSelectableFields = document.querySelectorAll('.consultation .selectable-field');
  const consultationSelections = document.querySelectorAll('.consultation .consultation-step-icon');
  const consultationHomeSelection = document.querySelector('.consultation .consultation-step-home');
  const consultationConsents = document.querySelectorAll('.consultation .consultation-consent input');
  const consultationPaymentOptions = document.querySelectorAll('.consultation .payment-option');
  const consultationRestartBtn = document.querySelector('.consultation .consultation-restart');
  const consultationRecommentationBtn = document.querySelector('.consultation .recommendation-btn');

  const getClickId = () => {
    try {
      const gcl_obj = JSON.parse(localStorage.getItem('_gcl_ls'));
      return gcl_obj?.gclid?.value?.value || null;
    } catch (error) {
      console.error('Invalid JSON in localStorage', error);
    }
  }

  const getGoogleAdId = (param) => {
    try {
      const stored = localStorage.getItem(param);
      console.log(stored);
      return stored || null;
    } catch (error) {
      console.error('Invalid JSON in localStorage', error);
      return null;
    }
  }

  const consultationVersion = () => {
    try {
      let cons_version = null;
      if(consultationSection.querySelector('.consultation-section-wrap')) {
        cons_version = 'Consultation Flow v5';
      } else if (window.location.pathname.indexOf('/book-a-consultation') < 0) {
        if(window.location.search.indexOf('lifestyle=home') > 0) {
          cons_version = 'Consultation Flow v4.home';
        } else {
          cons_version = 'Consultation Flow v4';
        }
        
      } else {
        cons_version = 'Consultation Flow v2a';
      }
      return cons_version;
    } catch (error) {
      console.error('Invalid Location Pathname', error);
    }
  }

  const getLifestyle = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const lifestyle = params.get('lifestyle');
      return lifestyle;
    } catch (error) {
      console.error('Invalid Lifestyle parameter', error);
    }
  }

  const getWearable = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const wearable = params.get('wearable');

      if(wearable) {
        consultationProgressBar.querySelector('.round-step:last-child').remove();
        console.log(consultationSteps);
        //const wearableStep = [...consultationSteps].find(step => step.dataset.tag === 'home_device');
        //wearableStep.remove();
      }

      return wearable;
    } catch (error) {
      console.error('Invalid Wearing Position parameter', error);
    }
  }

  if(consultationVersion() == 'Consultation Flow v4' && getLifestyle() == null) {
    // redirect to full flow
    if (!Shopify.designMode) {
      window.location = '/pages/book-a-consultation';
    }
  }

  let consultation_data = {
    id: null,
    first_name: null,
    surname: null,
    relationship: null,
    consent_sms: true,
    consent_email: true,
    email: null,
    phone: null,
    lifestyle: getLifestyle(),
    wearable: getWearable(),
    recommendation: null,
    is_completed: false,
    payment: null,
    information: null,
    version: consultationVersion(),
    gclid: getClickId(),
    gbraid: getGoogleAdId('gbraid'),
    wbraid: getGoogleAdId('wbraid')
  };

  let consultation_results = [];

  if(!consultationSection || !consultationNextBtn) {
    return false;
  }

  const updateProgressBar = (step) => {
    consultationProgressBar.querySelectorAll('.round-step[data-step]').forEach((round_step) => {
      if(step >= Number(round_step.dataset.step)) {
        round_step.classList.add('active');
      } else {
        round_step.classList.remove('active');
      }
    });
  }

  const updateAdditionalPanels = (step) => {
    if(consultationAdditionalPanels) {
      consultationAdditionalPanels.querySelectorAll('.additional-panels-wrapper[data-step]').forEach((panels_step) => {
        if(step == Number(panels_step.dataset.step)) {
          panels_step.classList.add('active');
        } else {
          panels_step.classList.remove('active');
        }
      });
    }
  }

  /*const closeConsultation = () => {
    let currentStep = consultationSection.querySelector('.consultation-step.active');
    sendConsultationDataLayerEvent(
      parseInt(currentStep),
      'cons_other_event', 
      currentStep.dataset.tag, 
      'Close',
      false,
      false
    );
    if(document.referrer && document.referrer.startsWith(document.location.origin)) {
      document.location = document.referrer;
    } else {
      document.location = document.location.origin;
    }
  }*/

  const storeSelection = (recommendation) => {
    window.localStorage.setItem('consultation-data', recommendation);
  }

  const storeAdditionalSelection = (consultationDetails) => {
    window.localStorage.setItem('consultation-data-details', consultationDetails);
  }

  const removeStoredSelection = () => {
    window.localStorage.removeItem('consultation-data');
  }

  const getStoredSelection = () => {
    if(window.localStorage.getItem('consultation-data')) {
      return window.localStorage.getItem('consultation-data');
    } else {
      return false;
    }    
  }

  const toggleBackBtn = (toggle) => {
    if(toggle == 'show') {
      //consultationPrevBtn.style.display = 'flex';
      consultationPrevBtn.classList.remove('disabled');
    } else {
      //consultationPrevBtn.style.display = 'none';
      consultationPrevBtn.classList.add('disabled');
    }
  }

  const fadeElementIn = (el) => {
    setTimeout(() => {
        el.style.opacity = 1;
    }, 200);
  }

  const validateStep = () => {
    // check current step has all fields filled and correct
    let error = false;
    let currentStep = consultationSection.querySelector('.consultation-step.active');

    // check selectables
    if(currentStep.querySelectorAll('.selectable-field').length > 0) {
      if(currentStep.querySelectorAll('.selectable-field input[type="radio"]:checked').length == 0){
        error = true;
        currentStep.querySelector('.selectable-field').classList.add('error');
      } else {
        currentStep.querySelector('.selectable-field').classList.remove('error');
        // store relationship
        if(currentStep.querySelector('.selectable-field#relationship-field')) {
          consultation_data.relationship = currentStep.querySelector('.selectable-field#relationship-field input:checked').value;
        }
      }
    }

    // check text fields
    if(!error && currentStep.querySelectorAll('input.field__input[type="text"]').length > 0) {
      currentStep.querySelectorAll('input.field__input[type="text"]').forEach((input) => {
        if(input.value.trim().length < 2) {
          error = true;
          input.classList.add('error');
        } else {
          input.classList.remove('error');
          // store name & surname
          if(input.name == 'name') {
            consultation_data.first_name = input.value;
            consultationSection.querySelectorAll("*").forEach(el => {
              if (el.children.length === 0 && el.textContent.includes("[name]")) {
                el.innerHTML = el.innerHTML.replaceAll(
                  "[name]",
                  `<span class="consultation-username">${consultation_data.first_name}</span>`
                );
              } else if(consultationSection.querySelectorAll('.consultation-username').length > 0) {
                consultationSection.querySelectorAll('.consultation-username').forEach((username) => {
                  username.textContent = consultation_data.first_name;
                });
              }
            });
          } else if(input.name == 'surname') {
            consultation_data.surname = input.value;
          }
        }
      });
    }

    // check email fields
    if(!error && currentStep.querySelectorAll('input.field__input[type="email"]').length > 0) {
      const email_regex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
      currentStep.querySelectorAll('input.field__input[type="email"]').forEach((input) => {
        if(input.value.trim() == ''){
          error = true;
          input.classList.add('error');
          input.classList.add('error-empty');
        } else if(!email_regex.test(input.value)) {
          error = true;
          input.classList.add('error');
          input.classList.remove('error-empty');
        } else {
          input.classList.remove('error');
          input.classList.remove('error-empty');
          consultation_data.email = input.value;
        }
      });
    }

    // check phone fields
    if(!error && currentStep.querySelectorAll('input.field__input[type="tel"]').length > 0) {
      const phone_regex = /^(?:\+44\s?7\d{9}|\+44\s?[1-3|8]\d{9,10}|0?7\d{9}|0[1-3|8]\d{9,10})$/; // /^(?:\+44\s?7\d{3}|\+44\s?[1-3|8]\d{3}|0?7\d{9}|0[1-3|8]\d{9,10})(?:[\s-]?\d{3,4})*$/;
      currentStep.querySelectorAll('input.field__input[type="tel"]').forEach((input) => {
        if(input.value.trim() == ''){
          error = true;
          input.classList.add('error');
          input.classList.add('error-empty');
        } else if(!phone_regex.test(input.value.replace(/\s|-/g, ''))) {
          error = true;
          input.classList.add('error');
          input.classList.remove('error-empty');
        } else {
          input.classList.remove('error');
          consultation_data.phone = input.value;
        }
      });
    }

    // check optionables
    if(!error && currentStep.querySelector('.consultation-step-icons')) {
      if(!currentStep.querySelector('.consultation-step-icons .consultation-step-icon.active') ||
      (currentStep.querySelector('.consultation-step-icons .consultation-step-icon.step-home-trigger.active') && 
      !currentStep.querySelector('.consultation-step-icons .consultation-step-icon.step-home.active'))) {
        error = true;
        currentStep.querySelector('.consultation-step-icons').classList.add('error');
      } else if(currentStep.dataset.tag == 'home_device') {
        // v4 home question
        consultation_data.wearable = currentStep.querySelector('.consultation-step-icons .consultation-step-icon.active').dataset.selection;
        consultation_data.recommendation = getRecommendation();
      } else {
        currentStep.querySelector('.consultation-step-icons').classList.remove('error');
        let step_data = currentStep.querySelector('.consultation-step-icons .consultation-step-icon:not(.step-home).active').dataset.selection;
        let step_data_home = currentStep.querySelector('.consultation-step-icons .consultation-step-icon.step-home.active')?.dataset.selection;
        if(step_data.indexOf('roam') >= 0) {
          consultation_data.lifestyle = 'roam';
          currentStep.dataset.lifestyle = 'roam';
          currentStep.dataset.wearable = step_data.split(',')[1];
          consultation_data.wearable = step_data.split(',')[1];
        }
        if(step_data.indexOf('home') >= 0) {
          consultation_data.lifestyle = 'home';
          currentStep.dataset.lifestyle = 'home';
          currentStep.dataset.wearable = step_data_home;
          consultation_data.wearable = step_data_home;
        }
        if(step_data.indexOf('home') >= 0 || step_data.indexOf('roam') >= 0) {
          consultation_data.recommendation = getRecommendation();
        }
      }
    }

    return error ? false : true;
  }

  const showNextStep = (step = null) => {

    if(!consultationSection.querySelector('.consultation-section-wrap')) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    if(step == 'thankyou') {
      consultationSection.querySelector(`.consultation-step.active`).classList.remove('active');
      consultationSection.querySelector(`.consultation-step.consultation-step-thanks`).classList.add('active');
      fadeElementIn(consultationSection.querySelector(`.consultation-step.consultation-step-thanks`));
      updateProgressBar(consultationSteps.length);
      updateAdditionalPanels(consultationSteps.length);
      showResults();
    } else {
    
      if(!validateStep()) {
        return false;
      }

      // show next step
      let currentStep = consultationSection.querySelector('.consultation-step.active');
      let nextStep = parseInt(currentStep.dataset.step) + 1;

      if(consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`) || nextStep > consultationSection.querySelectorAll('.consultation-step').length) {
        let step_answer = false;
        if(currentStep.querySelector('.selectable-field-option input:checked')) {
          step_answer = currentStep.querySelector('.selectable-field-option input:checked').value;
        } else if(currentStep.querySelector('.consultation-step-icon.active')) {
          step_answer = currentStep.querySelector('.consultation-step-icon.active').dataset.selection;
        } else if (currentStep.querySelector('.payment-option.selected')) {
          step_answer = currentStep.querySelector('.payment-option.selected').dataset.payment;
        }

        console.log(step_answer);

        if(consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`)) {
          consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`).classList.add('active');
          fadeElementIn(consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`));
          currentStep.classList.remove('active');
          updateProgressBar(nextStep);
          updateAdditionalPanels(nextStep);

          console.log('consultation_data.wearable',consultation_data.wearable);
          if(consultationSection.querySelector(`.consultation-step.active[data-tag="home_device"]`) && consultation_data.wearable) {
            consultationSection.querySelector(`.consultation-step.active[data-tag="home_device"] .consultation-step-icon[data-selection="${consultation_data.wearable}"]`).click();
            consultationNextBtn.click();
          }

          if(nextStep > 1) {
            toggleBackBtn('show');
          }
        }

        sendConsultationDataLayerEvent(
          parseInt(nextStep),
          'cons_step_submit', 
          currentStep.dataset.tag, 
          false,
          step_answer,
          false
        );

        if(nextStep > consultationSection.querySelectorAll('.consultation-step').length || 
           consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`).dataset.tag == 'thankyou') {
          consultation_data.is_completed = true;
          showResults();
          
        } else {

          postConsultationUserData(consultation_data)
          .then(res => console.log('Success:', res))
          .catch(err => console.error('Error:', err.message));
        }
      }

      
    }
  }

  const showPreviousStep = () => {
    if(!consultationSection.querySelector('.consultation-section-wrap')) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    let currentStep = consultationSection.querySelector('.consultation-step.active');
    let previousStep = parseInt(currentStep.dataset.step) - 1;

    sendConsultationDataLayerEvent(
      parseInt(previousStep),
      'cons_other_event', 
      consultationSection.querySelector(`.consultation-step[data-step="${previousStep}"]`).dataset.tag, 
      'Navigate Back', 
      false,
      false
    );

    consultationSection.querySelector(`.consultation-step[data-step="${previousStep}"]`).classList.add('active');
    currentStep.classList.remove('active');
    updateProgressBar(previousStep);
    updateAdditionalPanels(previousStep);
    consultationNextBtn.style.display = 'block';
    if(previousStep == 1) {
      toggleBackBtn('hide');
    }

    postConsultationUserData(consultation_data)
    .then(res => console.log('Success:', res))
    .catch(err => console.error('Error:', err.message));
  }

  const markSelection = (ev) => {
    let currentStep = consultationSection.querySelector('.consultation-step.active');
    if(!ev.currentTarget.classList.contains('step-home')) {
      currentStep.querySelector('.consultation-step-icon.active')?.classList.remove('active');
    }
    if(ev.currentTarget.dataset.selection.indexOf('home') >= 0) {
      consultationHomeSelection.classList.add('visible');
      consultationHomeSelection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else if (ev.currentTarget.classList.contains('step-home')) {
      consultationHomeSelection.querySelector('.consultation-step-icon.active')?.classList.remove('active');
    } else {
      consultationHomeSelection.classList.remove('visible');
    }
    ev.currentTarget.classList.add('active');
    if (ev.currentTarget.classList.contains('step-home')) {
      currentStep.querySelector('.step-home-trigger').dataset.selection = `home,${ev.currentTarget.dataset.selection}`;
    }
  }

  const getRecommendation = () => {
    let recommendation  = false;

    window.consultation_results.forEach((result) => {
      if(result.tags.indexOf(consultation_data.lifestyle) >= 0 && result.tags.indexOf(consultation_data.wearable) >= 0) {
        recommendation = result.product;
      }
    });

    return recommendation;
  }

  const showResults = () => {

    let recommendation = getRecommendation();
    
    if(recommendation) {
      consultation_data.recommendation = recommendation;
    }
    if(consultation_data.recommendation) {

      if(consultation_data.id && consultation_data.is_completed) {
        postConsultationUserData(consultation_data)
        .then(res => console.log('Success:', res))
        .catch(err => console.error('Error:', err.message));
      }

      storeSelection(consultation_data.recommendation);

      console.log('recommendation', recommendation);

      let additionalData = {
        relationship: consultation_data.relationship,
        cons_funnel_number: window.cons_funnel_number,
        payment: consultation_data.payment,
        first_name: consultation_data.first_name,
        surname: consultation_data.surname
      }
  
      storeAdditionalSelection(JSON.stringify(additionalData));

      if(consultationStepThanks) {
        consultationNextBtn.style.display = 'none';
        if(consultationRecommentationBtn) {
          consultationRecommentationBtn.href = `/products/${consultation_data.recommendation}`;
        }

      } else {
        //alert(`/products/${consultation_data.recommendation}?rel=${consultation_data.relationship}`);
        window.location.href = `/products/${consultation_data.recommendation}?rel=${consultation_data.relationship}`;
      }
    }

  }

  const restartConsultation = () => {
    if(confirm('Are you sure you want to restart?')) {
      sendConsultationDataLayerEvent(
        'last', 
        'consultation_interaction', 
        'Recommendation Page', 
        're_take', 
        false
      );
      removeStoredSelection();
      document.location = `${document.location.origin}${document.location.pathname}`;
    }
  }

  const revealHiddenFields = (ev) => {
    if(ev.currentTarget.querySelector('input[type="radio"]:checked')){
      ev.currentTarget.closest('.consultation-step-fields').querySelectorAll('.selectable-field-hidden').forEach((hiddenField) => {
        hiddenField.classList.add('visible');
      });
    }
  }

  const postConsultationUserData = async (data) => {

    console.log(data);

    if (!Shopify.designMode) {
    
      try {
        console.log(JSON.stringify(data));
        const response = await fetch('https://customer-central-source.careline-app.co.uk/genesys/online-lead', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        if (response.status === 422) {
          throw new Error('Invalid ID: The provided ID does not exist.');
        }
        if (response.status === 500) {
          throw new Error('Server error: Something unexpected happened.');
        }
        if (!response.ok) {
          throw new Error(`Unexpected error: ${response.status}`);
        }

        const result = await response.json();
        return result;

      } catch (error) {
        console.error('POST request failed:', error.message);
        throw error;
      }

    }
    
  }

  const updateConsultationConsent = (e) => {
    if (e.target.checked) {
      if(e.target.id == 'consent-email') {
        consultation_data.consent_email = true;
      } else if(e.target.id == 'consent-sms') {
        consultation_data.consent_sms = true;
      }
    } else {
      if(e.target.id == 'consent-email') {
        consultation_data.consent_email = false;
      } else if(e.target.id == 'consent-sms') {
        consultation_data.consent_sms = false;
      }
    }
  }

  const updateConsultationPaymentOption = (e) => {
    console.log(e);
    if(e.currentTarget.classList.contains('selected') && e.target.classList.contains('button')) {
      console.log('next step');
      consultation_data.payment = e.currentTarget.dataset.payment;
      consultationNextBtn.click();
    } else if (!e.currentTarget.classList.contains('selected')) {
      consultationPaymentOptions.forEach((consultationPaymentOption) => {
        consultationPaymentOption.classList.remove('selected');
      });
      e.currentTarget.classList.add('selected');
    }
  }

  const addConsultationEvents = () => {
    consultationSelections.forEach((consultationIcon) => {
      consultationIcon.addEventListener('click', markSelection);
    });
    //consultationCloseBtn.addEventListener('click', closeConsultation);
    consultationNextBtn.addEventListener('click', showNextStep);
    consultationPrevBtn.addEventListener('click', showPreviousStep);
    
    consultationSelectableFields.forEach((consultationSelectableField) => {
        consultationSelectableField.addEventListener('click', revealHiddenFields);
    });

    consultationConsents.forEach((consultationConsent) => {
        consultationConsent.addEventListener('change', updateConsultationConsent);
    });

    consultationPaymentOptions.forEach((consultationPaymentOption) => {
        consultationPaymentOption.addEventListener('click', updateConsultationPaymentOption);
    });

    if(consultationRestartBtn) {
      consultationRestartBtn.addEventListener('click', restartConsultation);
    }
  }

  const sendConsultationDataLayerEvent = (step, event, title, action, answer, result) => {

    //console.log(consultation_data);

    try {
      if(step == 'first') {
        title = false;
        window.cons_step = 0;
      } else if(step == 'last') {
          window.cons_step = window.cons_step ? window.cons_step+1 : 1;
      } else if(step > window.cons_step) {
        window.cons_step++;
      } else if(step < window.cons_step) {
         window.cons_step--;
      }
  
      window.cons_funnel_number++;

      let cons_event = {
        'event': event,
        'cons_type': 'Consultation Flow v2', 
        'cons_funnel_number': window.cons_funnel_number
      }

      if(window.cons_step > 0){
        cons_event.cons_step_number = window.cons_step;
      }

      if(title) {
        cons_event.cons_step_name = title;
      }

      if(action) {
        cons_event.cons_other_action = action;
      }
  
      if(answer) {
        cons_event.cons_answer = answer;
      } else if(result) {
        cons_event.cons_result = result;
      } 
  
      console.log(cons_event);
  
      dataLayer.push(cons_event);  
    } catch (error) {
      console.error(error);
    }
  }

  const startconsultation = () => {
    window.cons_funnel_number = 0;
    updateProgressBar(1);
    updateAdditionalPanels(1);
    fadeElementIn(consultationSection.querySelector('.consultation-step[data-step="1"]'));
    addConsultationEvents();

    const params = new URLSearchParams(window.location.search);
    const first_question = params.get('relation');

    console.log(first_question);
    console.log(decodeURIComponent(first_question));
    console.log(document.querySelector(`#relationship-field input[value="${decodeURIComponent(first_question)}"]`));

    if (first_question && document.querySelector(`#relationship-field input[value="${decodeURIComponent(first_question)}"]`)) {
      document.querySelector(`#relationship-field input[value="${decodeURIComponent(first_question)}"]`).click();
    } else {
      document.querySelector(`#relationship-field input[value="Unknown"]`).click();
    }

    postConsultationUserData(consultation_data)
    .then(res => {
      consultation_data.id = res.id;
      console.log('Success:', res);
    })
    .catch(err => console.error('Error:', err.message));

    sendConsultationDataLayerEvent(
      'first', 
      'cons_start', 
      consultationSection.querySelector('.consultation-step[data-step="1"]').dataset.tag, 
      false, 
      false,
      false
    );

    const replaceTitleTMs = () => {
      document.querySelectorAll(`.consultation .consultation-step-heading`).forEach((title) => {
          title.innerHTML = title.innerHTML.replace(
              /™/g,
              '<span class="tm">™</span>'
              );
      });
    }

    replaceTitleTMs();
  }

  if(getStoredSelection() != false) {
    console.log('stored',getStoredSelection());
    //consultation_data.recommendation = getStoredSelection();
    addConsultationEvents();

    if(consultation_data.recommendation && consultationStepThanks) {
      showNextStep('thankyou');
      if(consultationRestartBtn) {
        consultationRestartBtn.style.display = 'inline-flex';
      }
    } else {
      startconsultation();
    }

  } else {
    startconsultation();
  }
}

initConsultation();

